import { render, staticRenderFns } from "./BtSelect.vue?vue&type=template&id=fb875cb8&lang=pug"
import script from "./BtSelect.vue?vue&type=script&lang=js"
export * from "./BtSelect.vue?vue&type=script&lang=js"
import style0 from "./BtSelect.vue?vue&type=style&index=0&id=fb875cb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports